import React from "react";
const SuccessPage = () => {
  return <>Success</>;
};

export default SuccessPage;
